module.exports = __webpack_public_path__ + "static/img/icon_gydt.626534e5.png";